@import ../../../styles/helpers

$input_height: 55px

.chatAction
    &:hover
        background-color: transparent !important
    svg
        width: 30px !important
        height: 30px !important
        fill: white
    +m
        display: none !important

.container
    display: flex
    justify-content: space-between
    margin-top: 10px
    +m
        margin-top: 5px

    &__inputEmoji
        width: 23px
        height: 26px
        margin: auto
        margin-left: 15px
        margin-right: 31px
        +m
            margin-left: 20px
            margin-right: 20px

    &__inputLeft
        width: 100%

        input
            height: $input_height
            padding: 10px 25px
            background: $bordercolor
            border-radius: $border_radius_medium
            width: 100%
            color: white
            font-size: 18px !important
            +body
            &::placeholder
                opacity: 0.4
                color: white
            +m
                border-radius: 50px
                padding-left: 20px

    &__inputRight
        width: 140px
        display: flex
        height: $input_height
        justify-content: space-around
        gap: 40px
        margin-left: 35px
        margin-right: 25px
        background: transparent
        svg
            width: 35px !important
            height: 35px !important
        +m
            border-radius: 0
            padding-right: 20px
            margin-left: 30px
            margin-right: 10px
        &__send
            position: absolute
            color: #FFFFFF

        &__attach
            position: absolute
            color: #FFFFFF
            opacity: 0.4
            transform: rotate(45deg)

        &__emoj
            position: absolute
            color: #FFFFFF
            width: 30px !important
            height: 30px !important

        &__mic
            position: absolute
            color: #FFFFFF
            opacity: 0.4
        
            

.open_panel
    max-height: 60vh
    bottom: 7vh
    width: 100%
    overflow: hidden
    overflow-y: auto
    border-top: 1px solid $bordercolor
    border-radius: 0
    +m
        bottom: 15vh
        max-height: 50vh
        
    &::-webkit-scrollbar
        width: 8px
    &::-webkit-scrollbar-track
        background: transparent
        border-radius: 50px
        width: 8px
    &::-webkit-scrollbar-thumb
        background: $dark_icon_background
        border-radius: 50px
        width: 8px

.grid_container
    background-color: transparent
    padding: $external_margin
    margin: 0 auto
    width: 90%
    margin-top: 10px
    +s
        width: 100%


.emoji_container
    padding: 0px $external_margin
    .grid_container
        display: grid
        grid-template-columns: repeat( auto-fill, minmax( 40px, 1fr ) )
        

.grid_item
    padding: 5px
    font-size: 20px
    text-align: center
    cursor: pointer
    border-radius: 3px

    &:hover
        background-color: #1d232c
